import { message, Upload, UploadFile } from 'antd';
import { RcFile, UploadChangeParam } from 'antd/lib/upload';
import { ImageUploadProps } from 'enums/CreateProductModalEnums';
import React, { FC, useEffect, useRef, useState } from 'react';
import Camera from 'assets/icons/camera.svg';
import styles from './circleUploadComponent.module.scss';
import ErrorMessage from '../Error';

interface CircelUploadComponentProps {
  setImage: (fielName?: RcFile) => void;
  isDisabled?: boolean;
  errorMessage?: string;
  setFieldValue?: (fielName?: UploadFile[]) => void;
  file?: UploadFile[];
  fileListData?: UploadFile[];
  isFormik?: boolean;
}

const CircelUploadComponent: FC<CircelUploadComponentProps> = ({
  setImage,
  isDisabled,
  errorMessage,
  file,
  fileListData,
  isFormik = false,
}) => {
  const [fileList, setFileList] = useState<UploadFile[]>(fileListData ?? []);
  const uploadRef = useRef<React.ComponentRef<typeof Upload>>(null);
  useEffect(() => {
    const imageFile = isFormik ? fileListData?.[0]?.url : file?.[0]?.url;
    if (imageFile) {
      setFileList([
        {
          uid: '-1', // Unique ID for Ant Design
          name: 'existing-image.jpg',
          status: 'done', // Mark as uploaded
          url: imageFile, // Show in preview
        },
      ]);
    }
  }, [file, fileListData]);

  const beforeUpload = (file: RcFile) => {
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error(ImageUploadProps.ERROR_MESSAGE_SIZE);
      return Upload.LIST_IGNORE;
    }
    setImage(file);
    return false;
  };

  const handleUploadFileChange = (info: UploadChangeParam) =>
    setFileList?.(info.fileList);

  const removeFile = () => {
    if (!isFormik) {
      uploadRef?.current?.upload?.uploader?.fileInput?.click();
      return false;
    } else {
      setImage(undefined);
      return true;
    }
  };
  return (
    <div className={styles.uploadContainer}>
      <Upload
        ref={uploadRef}
        data-testid="file-upload"
        disabled={isDisabled}
        name={ImageUploadProps.FIELD_NAME}
        listType={ImageUploadProps.LIST_TYPE}
        /** set showUpload List to false, to preview image in place of
         *the upload button, else it would show it as a list of uploaded images */
        showUploadList={{
          showDownloadIcon: false,
          showPreviewIcon: false,
        }}
        beforeUpload={beforeUpload}
        accept="image/png, image/jpeg"
        maxCount={1}
        onChange={handleUploadFileChange}
        fileList={fileList}
        onRemove={removeFile}>
        {!fileList?.length ? (
          <div className={styles.uploadIcon}>
            <img src={Camera} alt={ImageUploadProps.ICON_ALT} />
          </div>
        ) : null}
      </Upload>
      {errorMessage && <ErrorMessage message={errorMessage} />}
    </div>
  );
};

export default CircelUploadComponent;
